// extracted by mini-css-extract-plugin
export var base = "_17-0";
export var updateBanner = "_17-1";